import { useState } from "react";

import { Column, Row } from "../../components";
import { UiTabModel } from "../../models";
import { renderViewModels } from "../../render-view-model";

import { Button, Title } from "./UiTab.styles";

export type UiTabProps = {
    readonly model: UiTabModel;
};

const UiTab = ({ model }: UiTabProps) => {
    const { buttonText, columns, title } = model.content;

    const [isSelected, setIsSelected] = useState(false);

    return (
        <>
            <Row>
                <Column>
                    <Button onClick={() => setIsSelected(true)}>
                        {buttonText}
                    </Button>
                </Column>
            </Row>
            {isSelected && (
                <>
                    {title && <Title>{title}</Title>}
                    <Row>{renderViewModels(columns)}</Row>
                </>
            )}
        </>
    );
};

export default UiTab;
